import React from 'react';
import aboutImage from '../../assets/About/about_logo.jpg'

const AboutWelcome = () => (
 
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start mb-8 px-2 py-6 md:px-0">
    <div data-aos="fade-right">
      <img
        src={aboutImage}
        alt="About Us"
        className="rounded-lg shadow-md w-full h-auto object-cover img-fluid"
      />
    </div>
    <div className="text-gray-700 text-sm md:text-base lg:text-md 2xl:text-xl space-y-4" data-aos="fade-left">
      <p>
        Established in 2013, ESMOB Technologies has been at the forefront of digital transformation,
        empowering startups and enterprises to harness the power of emerging technologies. Our mission is to scale
        businesses by delivering competitive advantages through world-class digital services at affordable prices.
        With a commitment to innovation and technical excellence, we specialize in creating intelligent, scalable,
        and secure solutions tailored to diverse industry needs.
      </p>
      <p>
        Our comprehensive suite of services includes custom software development, mobile and web application
        development, IoT solutions, artificial intelligence, and software consulting. By leveraging the latest
        tools, frameworks, and strategies, we ensure that our clients receive solutions that are not only
        cutting-edge but also aligned with their unique business objectives. Our agile methodologies and
        customer-centric approach enable us to deliver projects on time, maintaining the highest quality
        standards.
      </p>
      <p>
        At ESMOB Technologies, we pride ourselves on our ability to adapt to the evolving technological landscape.
        Our team of dedicated professionals stays abreast of the latest industry developments, ensuring that we
        provide innovative solutions that drive growth and efficiency. By fostering trusted partnerships and
        focusing on continuous improvement, we aim to be the preferred technology partner for businesses seeking
        to navigate the complexities of the digital age.
      </p>
    </div>
  </div>
  
);

export default AboutWelcome;